import axios from 'axios';

const backend = axios.create({
    timeout: 0, // TODO: Choose a reasonable timeout amount
    baseURL: process.env.VUE_APP_API_URL
});

backend.interceptors.request.use(function (config) {
    console.log('%c=> BACKEND: %s %s %o', 'background: #3c8be9; color: white;padding:5px;border-radius:5px;', config?.method, config?.url, config);
    config.startTime = new Date().getTime();
    return config;
}, function (error) {
    console.log('%c=> BACKEND: %s %s %o', 'background: #ff6e34; color: white;padding:5px;border-radius:5px;', error?.config?.method, error?.config?.url, error);
    return Promise.reject(error);
});
backend.interceptors.response.use(async function (response) {
    // await new Promise(r => setTimeout(r, 20000)); //TODO syam make this a session config to simulate backend delays and trigger error messages and page routing
    response?.data?.content && (response.data.content = _CONTENT_OVERRIDE_[ response.config.url.split(':')[0]] || response?.data?.content)
    response?.data?.redirectURL && !Array.isArray(response.data.redirectURL) && (response.data.redirectURL = [response.data.redirectURL])
    console.log('%c<= BACKEND: %s %s %s-%s [%dms] %o', 'background: #56bb3c; color: white;padding:5px;border-radius:5px;',
        response?.config?.method, response?.config?.url, response?.status, response?.statusText, new Date().getTime() - response?.config?.startTime, response);
    return response;
}, function (error) {
    console.log('%c<= BACKEND: %s-%s %dms %s %o', 'background: #ff6e34; color: white;padding:5px;border-radius:5px;', error?.response?.status, error?.response?.statusText,
        new Date().getTime() - error?.config?.startTime, error?.message, error);
    return Promise.reject(error);
});

backend.getData = function (url, cbk) {
    let xWaffle = sessionStorage.getItem("x-waffle");
    if (!cbk) {
        return backend.get(url, {
            headers: {
                'Client': 'pemco',
                'x-waffle' : xWaffle
            }
        })
    }
    backend.get(url, {
        headers: {
            'Client': 'pemco',
            'x-waffle' : xWaffle
        }
    }).then(response => {
        response.headers['x-waffle'] && sessionStorage.setItem('x-waffle', response.headers['x-waffle']);
        cbk(response);
    }).catch(e=> {
        console.warn(e)
        cbk(null)
    });
};

backend.postData = function (url, data, cbk) {
    let xWaffle = sessionStorage.getItem("x-waffle");
    if (!cbk) {
        return backend.post(url, data, {
            headers: {
                'Client': 'pemco',
                'x-waffle' : xWaffle
            }
        })
    }
    backend.post(url, data, {
        headers: {
            'Client': 'pemco',
            'x-waffle' : xWaffle
        }
    }).then(response => {
        response.headers['x-waffle'] && sessionStorage.setItem('x-waffle', response.headers['x-waffle']);
        cbk(response);
    }).catch(e=> {
        console.warn(e)
        cbk(null)
    });
};

export default backend;const _CONTENT_OVERRIDE_ = {
    "auto/start":``,
};